import { client } from "./api";

export const quotesCatalog = () => client.get("/quotes/catalog").then((r) => r.data.items);
export const quoteRequest = (payload) => client.post("/quotes/request", payload).then((r) => r.data);
// Opened by the owner (admin logged in on this device, or ?preview=1 from the Admin link) → does not count as "viewed by the customer".
export const isOwnerPreview = () => !!localStorage.getItem("admin_token") || new URLSearchParams(window.location.search).get("preview") === "1";
export const quotePublic = (token) => client.get(`/quotes/p/${token}`, { params: isOwnerPreview() ? { preview: 1 } : {} }).then((r) => r.data);
export const quoteAccept = (token) => client.post(`/quotes/p/${token}/accept`).then((r) => r.data);
export const quotePaidCheck = (token) => client.get(`/quotes/p/${token}/paid-check`).then((r) => r.data);
export const quoteDecline = (token, reason) => client.post(`/quotes/p/${token}/decline`, { reason }).then((r) => r.data);

export const adminQuotes = (status = "") => client.get("/admin/quotes", { params: status ? { status } : {} }).then((r) => r.data.items);
export const adminQuoteCreate = (payload) => client.post("/admin/quotes", payload).then((r) => r.data);
export const adminQuoteUpdate = (id, payload) => client.put(`/admin/quotes/${id}`, payload).then((r) => r.data);
export const adminQuoteDelete = (id) => client.delete(`/admin/quotes/${id}`).then((r) => r.data);
export const adminQuoteSend = (id) => client.post(`/admin/quotes/${id}/send`).then((r) => r.data);
export const adminQuoteAiDraft = (payload) => client.post("/admin/quotes/ai-draft", payload).then((r) => r.data);
export const adminQuoteCatalog = () => client.get("/admin/quotes/catalog").then((r) => r.data.items);
export const adminQuoteCatalogSave = (items) => client.put("/admin/quotes/catalog", items).then((r) => r.data.items);
export const adminQuoteRooms = (checkin, checkout, adults) => client.get("/admin/quotes/rooms", { params: { checkin, checkout, adults } }).then((r) => r.data);

export const eur = (cents) => `€ ${((cents || 0) / 100).toFixed(2).replace(".", ",")}`;
export const STATUS_LABEL = {
  request: ["Richiesta", "bg-amber-100 text-amber-900"],
  draft: ["Bozza", "bg-stone-100 text-stone-700"],
  sent: ["Inviato", "bg-sky-100 text-sky-900"],
  viewed: ["Visto", "bg-indigo-100 text-indigo-900"],
  accepted: ["Accettato", "bg-emerald-100 text-emerald-900"],
  deposit_paid: ["Caparra pagata", "bg-emerald-600 text-white"],
  declined: ["Rifiutato", "bg-red-100 text-red-900"],
  expired: ["Scaduto", "bg-stone-200 text-stone-600"],
};
